import React, { useState, useEffect } from 'react';
import Button from '../../../components/ui/Button';
import httpHelper, { Method_TYPE } from 'utils/http-helper';
import URL_CONSTANTS from 'constants/url-constants';
import DataTable from 'react-data-table-component';
import Select from '../../../components/ui/Select';
import PeriodsModal from './PeriodsModal';
import { formatDate } from '../../../utils/monthConvert';
import { toast } from 'react-hot-toast';

const PeriodsPage = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [selectedPoint, setSelectedPoint] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [dataTableData, setDataTableValue] = useState([]);
    const [originalData, setOriginalData] = useState([]);
    const [batchOptions, setBatchOptions] = useState([]);
    const [periodOptions, setPeriodOptions] = useState([]);
    const [selectedPeriod, setSelectedPeriod] = useState('');
    const [selectedBatch, setSelectedBatch] = useState('');
    const [batchDetails, setBatchDetails] = useState([]);

    useEffect(() => {

        fetchData();
    }, []);

    // after your states
useEffect(() => {
    if (selectedPeriod && batchDetails.length > 0) {
        const filteredBatches = batchDetails.filter(
            batch => batch.periodId === selectedPeriod
        );

        setBatchOptions(
            filteredBatches.map(batch => ({
                label: batch.name,
                value: batch.id
            }))
        );

        // Reset selectedBatch when period changes
        setSelectedBatch(filteredBatches.length > 0 ? filteredBatches[0].id : '');
    }
}, [selectedPeriod, batchDetails]);

    const fetchData = async () => {
        const periods = await getPeriodsValue();
        await getBatchValue(periods); // Pass periods directly to avoid timing issues
        setIsLoading(false);
    };

    const getPeriodsValue = async () => {
        try {
            const data = await httpHelper(URL_CONSTANTS.PERIODS, Method_TYPE.GET);
            const formattedTableData = data?.map((period, index) => ({
                slno: index + 1,
                name: period?.name,
                start: formatDate(period?.startDate),
                end: formatDate(period?.endDate),
                id: period?._id
            }));

            setPeriodOptions(
                data?.map(period => ({
                    label: period?.name,
                    value: period?._id
                }))
            );
            setDataTableValue(formattedTableData);
            setOriginalData(formattedTableData);

            return formattedTableData; // return periods for matching
        } catch (err) {
            console.error('Error fetching periods:', err);
            return [];
        }
    };

    const getBatchValue = async (periodsList) => {
        try {
            const data = await httpHelper(URL_CONSTANTS.GET_BATCH_INFO, Method_TYPE.GET);
            const formattedTableData = data?.data?.map(batch => ({
                name: batch?.name,
                isCurrent: batch?.isCurrent,
                id: batch?._id,
                periodId: batch?.period,
                startDate: batch?.startDate,
                endDate: batch?.endDate
            }));

            setBatchDetails(formattedTableData);

            const currentBatch = formattedTableData.find(b => b.isCurrent);
            if (currentBatch) {
                setSelectedBatch(currentBatch.id);
                const matchedPeriod = periodsList.find(p => p.id === currentBatch.periodId);
                if (matchedPeriod) {
                    setSelectedPeriod(matchedPeriod.id);
                }
            }
        } catch (err) {
            console.error('Error fetching batches:', err);
        }
    };

    const updateBatch = async () => {
        try {
            let updateRes= await httpHelper(`${URL_CONSTANTS.UPDATE_BATCH}${selectedBatch}/current`, Method_TYPE.PATCH);
            if(updateRes?.isCurrent){
               toast.success("Batch Info Saved Successfully..!", {
                icon: null,
                style: {

                    background: 'green',
                    color: 'white',
                },
            });

            }
            const periods = await getPeriodsValue();
            await getBatchValue(periods);
        } catch (err) {
            console.error('Error updating batch:', err);
        }
    };

const handleDelete = async (rowId) => {
    if (!window.confirm("Are you sure you want to delete this period?")) return;

    try {
        await httpHelper(`${URL_CONSTANTS.DELETE_PERIODS}`, Method_TYPE.POST,`_id=${rowId}`);
        fetchData(); // Refresh after deletion
    } catch (err) {
        console.error("Error deleting period:", err);
    }
};


    const handleAddNew = () => {
        setSelectedPoint(null);
        setIsModalOpen(true);
    };

    const handleEdit = (rowId) => {
        const editValue = originalData?.find(detail => detail.id === rowId);
        console.log("editValue button",editValue)
        setSelectedPoint(editValue);
        setIsModalOpen(true);
    };

    const handlePeriodFilter = (periodId) => {
        setSelectedPeriod(periodId);
    };

    const handleBatchFilter = (batchId) => {
        setSelectedBatch(batchId);
    };

const columns = [
    {
        name: 'Sl.No',
        selector: row => row.slno,
        sortable: true,
        cell: row => <div data-title="Sl.No">{row.slno}</div>
    },
    {
        name: 'Name',
        selector: row => row.name,
        cell: row => (
            <div className="flex items-center gap-2" data-title="Name">
                <span>{row.name}</span>
                {row.id === selectedPeriod && (
                    <span
                        className="px-2 py-1 text-xs font-bold text-white rounded"
                        style={{ backgroundColor: '#C0A000' }}
                    >
                        CURRENT
                    </span>
                )}
            </div>
        )
    },
    {
        name: 'Start',
        selector: row => row.start,
        sortable: true,
        cell: row => <div data-title="Start">{row.start}</div>
    },
    {
        name: 'End',
        selector: row => row.end,
        sortable: true,
        cell: row => <div data-title="End">{row.end}</div>
    },
    {
        name: 'Actions',
        cell: row => (
            <div className="flex gap-2" data-title="Actions">
                <Button variant="ghost" size="sm"
                    iconSize="16"
                    onClick={() => handleEdit(row.id)}
                    iconName="Edit"
                    iconPosition="left"
                >
                    <span className='inline-block lg:inline-block'>Edit</span>
                </Button>
                <Button variant="destructive" size="sm" iconSize="16" onClick={() => handleDelete(row.id)} iconName="Trash" iconPosition="left">
                    <span className='inline-block lg:inline-block'>Delete</span>
                </Button>
            </div>
        ),
        ignoreRowClick: true,
        allowOverflow: true,
        button: true
    }
];


    return (
        <>
            <div className="p-4 text-center border-border bg-white bg-card border rounded-lg shadow-spiritual-sm border-b-0 rounded-bl-none rounded-br-none relative">
                <div className="flex justify-between mb-0 md:flex-row flex-col">
                    <div className='flex gap-2 flex-col md:flex-row'>
                        <Select
                        placeholder="Current Period"
                        options={periodOptions}
                        value={selectedPeriod}
                        onChange={handlePeriodFilter}
                    />

                    <Select
                        placeholder="Current Batch"
                        options={batchOptions}
                        value={selectedBatch}
                        onChange={handleBatchFilter}
                    />
                    </div>

                    <div className='flex mt-2 md:mt-0 justify-end'>
                        <button
                            type='button'
                            className='inline-flex md:h-full mr-4 w-36 items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 border border-input hover:bg-gray-500 hover:text-white text-white rounded-md bg-gray-400 px-3'
                            onClick={updateBatch}
                        >
                            Save
                        </button>
                        <button
                            type='button'
                            className='hover:text-accent-foreground w-36 max-w-32 inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 bg-primary text-primary-foreground hover:bg-accent h-10 px-4 py-2'
                            onClick={handleAddNew}
                        >
                            Add
                        </button>
                    </div>
                </div>
            </div>

            <DataTable
                columns={columns}
                data={dataTableData}
                fixedHeader
                fixedHeaderScrollHeight='500px'
                defaultSortFieldId={1}
                className='reports-table'
            />

            <PeriodsModal
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                selectedPoint={selectedPoint}
                fetchData={fetchData}
                batchDetails={batchDetails}
            />
        </>
    );
};

export default PeriodsPage;
